//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,countDownTimeFunc} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';
import * as dd from 'dingtalk-jsapi';

export default {
  name: "MessageUrl",
  components: {
    footerNav
  },
  data() {
    return {
      value:''
    }
  },
  created() {
    dd.device.base.getPhoneInfo({
      onSuccess: function(data) {
        window.location.href = this.$route.query.mobile
      },
      onFail: function(err) {
        window.location.href = this.$route.query.pc
      }
    });
  },
  mounted() {
  },
  updated() {
    document.scrollingElement.scrollTop = 0
  },
  methods: {
    onSearch(){

    },
    toDetail(){
      this.$router.push({name:'purchaseDetail'})
    },
    addSend(){
      this.$router.push({name:'sendOrderAdd'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/messageUrl/index.vue